import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 2.33594C9.38 2.33594 7.25 4.46594 7.25 7.08595C7.25 9.65595 9.26 11.736 11.88 11.826C11.96 11.816 12.04 11.816 12.1 11.826C12.12 11.826 12.13 11.826 12.15 11.826C12.16 11.826 12.16 11.826 12.17 11.826C14.73 11.736 16.74 9.65595 16.75 7.08595C16.75 4.46594 14.62 2.33594 12 2.33594Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.079 14.4848C14.289 12.6248 9.73899 12.6248 6.92899 14.4848C5.65899 15.3348 4.95898 16.4849 4.95898 17.7149C4.95898 18.9449 5.65899 20.0849 6.91899 20.9249C8.31899 21.8649 10.159 22.3349 11.999 22.3349C13.839 22.3349 15.679 21.8649 17.079 20.9249C18.339 20.0749 19.039 18.9349 19.039 17.6949C19.029 16.4649 18.339 15.3248 17.079 14.4848Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgProfile);
export default ForwardRef;
